import React from "react";
import { Pie } from "react-chartjs-2";

const ProjectWpTaskPieChart = ({ stats, role }) => {
  if (!stats.projectCount && !stats.workpackageCount && !stats.taskCount)
    return <p>No data to display</p>;

  const roleConfig = {
    superadmin: ["Projects", "Workpackages", "Tasks"],
    "assistant superadmin": ["Projects", "Workpackages", "Tasks"],
    auditor: ["Projects", "Workpackages", "Tasks"],
    manager: ["Workpackages", "Tasks"],
    staff: ["Tasks"],
  };

  const roleLabels = roleConfig[role] || [];
  const labels = roleLabels;

  const values = roleLabels.map((label) => {
    switch (label) {
      case "Projects":
        return stats.projectCount || 0;
      case "Workpackages":
        return stats.workpackageCount || 0;
      case "Tasks":
        return stats.taskCount || 0;
      default:
        return 0;
    }
  });

  const data = {
    labels,
    datasets: [
      {
        label: "Count",
        data: values,
        backgroundColor: ["#36A2EB", "#FFCE56", "#FF6384"],
        hoverOffset: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
    },
  };

  return <Pie data={data} options={options} />;
};

export default ProjectWpTaskPieChart;
